// extracted by mini-css-extract-plugin
export default {"rightPanelShiftBreakpoint":"1252px","rightPanelWidth":"336px","sidebarShiftBreakpoint":"1166px"};